import HorizontalBarChartWidget from './HorizontalBarChartWidget';

export default HorizontalBarChartWidget;
